module.exports = __webpack_public_path__ + "img/index-spot-2.0dbdab9d.png";